import React, { useEffect } from 'react';
import RsBreadcrumbs from '@Pages/RetroSynthesis/RsBreadcrumbs/RsBreadcrumbs';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import isUndefined from 'lodash/isUndefined';
import { fetchProjectBreadcrumbInfoAction, fetchProjectsCountAction } from '@Pages/RetroSynthesis/RsBreadcrumbs/actions';
import {
  getProjectsCount,
  getProjectsInfoMap,
  getRemovedProjectIds,
  getRemovedRouteIds,
} from '@Pages/RetroSynthesis/RsBreadcrumbs/selector';
import { routeType } from '@Pages/RetroSynthesis/ProjectRoute/selectors';

/* eslint-disable react/prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
function RsBreadcrumbsContainer({
  projectsCount,
  location,
  history,
  projectsInfoMap,
  fetchProjectInfo,
  fetchProjectsCount,
  // eslint-disable-next-line no-shadow
  routeType,
  removedProjectIds,
  removedRouteIds,
}) {
  useEffect(() => {
    // fetch count if undefined only
    if (isUndefined(projectsCount)) {
      fetchProjectsCount();
    }
  }, [projectsCount]);

  return (
    <RsBreadcrumbs
      projectsCount={projectsCount}
      projectsInfoMap={projectsInfoMap}
      location={location}
      history={history}
      fetchProjectInfo={fetchProjectInfo}
      routeType={routeType}
      removedProjectIds={removedProjectIds}
      removedRouteIds={removedRouteIds}
    />
  );
}

const mapActionToProps = {
  fetchProjectInfo: fetchProjectBreadcrumbInfoAction,
  fetchProjectsCount: fetchProjectsCountAction,
};

const mapStateToProps = (state) => ({
  projectsCount: getProjectsCount(state),
  projectsInfoMap: getProjectsInfoMap(state),
  routeType: routeType(state),
  removedProjectIds: getRemovedProjectIds(state),
  removedRouteIds: getRemovedRouteIds(state),
});

export default connect(mapStateToProps, mapActionToProps)(withRouter(RsBreadcrumbsContainer));
